import React from "react";

const MyCourse = () => {
  const courseData = [
    {
      id: "1",
      image: "/Images/web-developemnt.png",
      title: "Full Stack Development",
      duration: "6 Months",
      fee: "₹1.5L (0% EMI)",
      teacherName: "Mr. Arjun Rao",
      startOn: "1st August 2025",
      description: "Become a full stack developer using MERN stack.",
      category: "Development",
      language: "English",
      videoLink: "https://example.com/fsd-video",
    },
    {
      id: "2",
      image: "/Images/ui-ux.png",
      title: "UI/UX Design",
      duration: "3 Months",
      fee: "₹80K",
      teacherName: "Ms. Meera Sharma",
      startOn: "15th August 2025",
      description: "Learn Figma, Adobe XD and design systems.",
      category: "Design",
      language: "English",
      videoLink: "https://example.com/uiux-video",
    },
  ];

  return (
    <>
      <h1 className="text-2xl font-bold mb-4 text-[#2B3DA8]">My Courses</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {courseData.map((course) => (
          <div key={course.id} className="bg-white p-5 rounded-lg shadow hover:shadow-md transition">
            <h2 className="text-xl font-semibold mb-1 text-[#2B3DA8]">{course.title}</h2>
            <p className="text-[#2B3DA8]">{course.teacherName}</p>
            <p className="text-sm text-[#2B3DA8]">
              Duration: <span className="text-black">{course.duration}</span> • Starts:{" "}
              <span className="text-black">{course.startOn}</span>
            </p>
            <p className="mt-2 text-[#2B3DA8] text-sm">
              <span className="text-black">{course.description}</span>
            </p>
            <p className="text-sm text-[#2B3DA8] mt-1">
              Fee: <span className="text-black">{course.fee}</span>
            </p>
            <p className="text-sm text-[#2B3DA8]">
              Language: <span className="text-black">{course.language}</span>
            </p>
            <a
              href={course.videoLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#2B3DA8] hover:underline inline-block mt-3"
            >
              Watch Intro Video
            </a>
          </div>
        ))}
      </div>
    </>
  );
};

export default MyCourse;
